module.exports = __webpack_public_path__ + "img/caf-done.3bcfd089.png";